<template>
  <div class="mid_scroll_content">
    <section class="forecastPortfolio border-0">
      <div class="row mt-md-4">
        <div class="col-12 col-lg-8 mainSpace">
          <div
            class="mainTitle mb-4 d-flex align-items-center justify-content-between"
          >
            <div class="leftContet">
              <h3>Dashboard</h3>
              <p class="f-16">Track, Manage, and Forecast your portfolio</p>
            </div>
            <div class="selectmenu position-relative">
              <a
                @click.prevent="currencies = !currencies"
                href="javascript:void(0)"
                class="btn d-flex align-items-center"
                ><span class="mx-2">In {{ selectedCurrency }}</span
                ><feather type="chevron-down" class="ml-2"></feather
              ></a>
              <ul
                class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
                :class="currencies ? 'show' : ''"
              >
                <li
                  v-for="c in availableCurrencies"
                  v-if="c != selectedCurrency"
                >
                  <a
                    href="javascript:void(0)"
                    @click.prevent="
                      selectedCurrency = c;
                      currencies = !currencies;
                    "
                    >In {{ c }}</a
                  >
                </li>
                <!-- <li><a href="javascript:void(0)">In USDT</a></li>
                <li>
                  <a href="javascript:void(0)"> In ETH</a>
                </li> -->
              </ul>
            </div>
            <!-- <change-account></change-account> -->
          </div>
          <div class="d-flex align-items-center showHolding">
            <div class="card-body">
              <p class="cardHead">ESTIMATED HOLDING VALUE (in {{ selectedCurrency }} )</p>
              <h3 class="secondarycolor">
                {{ formatPrice(totalBtcValue, true) }}
              </h3>
            </div>
            <div class="card-body mx-4">
              <p class="cardHead">Total Deposits</p>
              <h3 class="secondarycolor">
                <span class="ipadBlock">{{ depsitList.totalRecords }}</span> Deposits
                <!-- +$500 <span class="f-14 textcolor">USD</span> -->
              </h3>
            </div>
            <div class="card-body">
              <p class="cardHead">Total Withdrawals</p>
              <h3 class="secondarycolor">
                <span class="ipadBlock">{{ withdrawalList.totalRecords }}</span> Withdrawals
                <!-- {{ totalUsdValue }} <span class="f-14 textcolor">USD</span> -->
              </h3>
            </div>
          </div>
          <div class="dashChart blockSpace">
            <h3 class="semibold mb-3">Total Deposit Volume</h3>
            <div class="mainChart p-2">
              <div
                class="d-flex align-items-center justify-content-between p-2 mb-3"
              >
                <div class="tVolume">
                  <p class="mb-1">Total Deposit Volume in past 15 days</p>
                  <h5 class="medium mb-0">
                    ${{ formatPrice(totalTransactionVolumne) }}
                  </h5>
                </div>
                <!-- <div class="selectmenu position-relative">
                  <a
                    @click.prevent="targetTime = !targetTime"
                    href="javascript:void(0)"
                    class="btn d-flex align-items-center"
                    ><span class="mx-2">This Month</span>
                    <feather type="chevron-down" class="ml-2"></feather
                  ></a>
                  <ul
                    class="dropdown_menu dropdown_menu--animated dropdown_menu-6"
                    :class="targetTime ? 'show' : ''"
                  >
                    <li><a href="javascript:void(0)">This Year</a></li>
                    <li><a href="javascript:void(0)">This Month</a></li>
                    <li><a href="javascript:void(0)">This Week</a></li>
                  </ul>
                </div> -->
              </div>
              <revenueChart />
              <!-- <img
                class="w-100 d-block"
                src="../../../../static/website/images/homegraph.svg"
                alt="Icon"
              /> -->
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="d-flex align-items-center justify-content-center flex-wrap">
            <router-link to="/smart-trading" class="cap_btn mr-2"
              >Instant Conversion</router-link
            >
            <router-link
              :to="{ path: '/deposit-withdrawal', query: { withdraw: 'BTC' } }"
              class="cap_btn secondaryBG"
              >Withdraw</router-link
            >
          </div>
          <div class="topWalletbalances">
            <h3 class="semibold mb-3">Wallet Balances</h3>
            <VueSlickCarousel
              v-if="Object.keys(margin_list).length"
              v-bind="settings"
              :arrows="true"
            >
              <div
                v-for="(wallet, key) in margin_list"
                class="card-body position-relative" v-if="wallet.freemargin!=0"
              >
                <div class="d-flex align-items-center">
                  <span class="flex-shrink-0">
                    <img
                      width="40"
                      :src="
                        '../../../../static/website/images/crypto_logos/' +
                        wallet.currency.toLowerCase() +
                        '.png'
                      "
                      alt="ABBC"
                    />
                  </span>
                  <div class="flex-grow-1 ml-3">
                    <h4 class="mb-0 semibold">{{ wallet.currency }}</h4>
                    <p class="f-14 mb-0">{{ getCurrName(wallet.currency) }}</p>
                  </div>
                </div>
                <!-- <div class="strip position-absolute">#2</div> -->
                <div
                  class="cardFooter d-flex align-items-center justify-content-between"
                >
                  <div class="ltBlock">
                    <p>Balance</p>
                    <h4 class="mb-0 themecolor semibold">
                      {{ wallet.freemargin }}
                    </h4>
                  </div>
                  <div class="change">
                    <p>24h Change</p>
                    <p
                      class="mb-0 status d-flex align-items-center"
                      :class="{
                        greenBG: getCurrencyChange(wallet.currency) > 0,
                        redBG: getCurrencyChange(wallet.currency) < 0,
                      }"
                    >
                      <feather
                        v-if="getCurrencyChange(wallet.currency) < 0"
                        class="mr-1"
                        type="trending-down"
                      ></feather>
                      <feather
                        v-if="getCurrencyChange(wallet.currency) > 0"
                        class="mr-1"
                        type="trending-up"
                      ></feather>
                      {{ getCurrencyChange(wallet.currency) }}%
                    </p>
                  </div>
                </div>
              </div>
              <!-- <div class="card-body position-relative">
                <div class="d-flex align-items-center">
                  <span class="flex-shrink-0">
                    <img
                      width="40"
                      src="../../../../static/website/images/crypto_logos/btc.png"
                      alt="ABBC"
                    />
                  </span>
                  <div class="flex-grow-1 ml-3">
                    <h4 class="mb-0 semibold">BTC</h4>
                    <p class="f-14 mb-0">Bitcoin</p>
                  </div>
                </div>
                <div class="strip position-absolute">#2</div>
                <div
                  class="cardFooter d-flex align-items-center justify-content-between"
                >
                  <div class="ltBlock">
                    <p>Balance</p>
                    <h4 class="mb-0 themecolor semibold">₿0.05200295</h4>
                  </div>
                  <div class="change">
                    <p>24h Change</p>
                    <p class="mb-0 status greenBG d-flex align-items-center">
                      <feather class="mr-1" type="trending-up"></feather>
                      0.0212%
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-body position-relative">
                <div class="d-flex align-items-center">
                  <span class="flex-shrink-0">
                    <img
                      width="40"
                      src="../../../../static/website/images/crypto_logos/btc.png"
                      alt="ABBC"
                    />
                  </span>
                  <div class="flex-grow-1 ml-3">
                    <h4 class="mb-0 semibold">BTC</h4>
                    <p class="f-14 mb-0">Bitcoin</p>
                  </div>
                </div>
                <div class="strip position-absolute">#2</div>
                <div
                  class="cardFooter d-flex align-items-center justify-content-between"
                >
                  <div class="ltBlock">
                    <p>Balance</p>
                    <h4 class="mb-0 themecolor semibold">₿0.05200295</h4>
                  </div>
                  <div class="change">
                    <p>24h Change</p>
                    <p class="mb-0 status greenBG d-flex align-items-center">
                      <feather class="mr-1" type="trending-up"></feather>
                      0.0212%
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-body position-relative">
                <div class="d-flex align-items-center">
                  <span class="flex-shrink-0">
                    <img
                      width="40"
                      src="../../../../static/website/images/crypto_logos/btc.png"
                      alt="ABBC"
                    />
                  </span>
                  <div class="flex-grow-1 ml-3">
                    <h4 class="mb-0 semibold">BTC</h4>
                    <p class="f-14 mb-0">Bitcoin</p>
                  </div>
                </div>
                <div class="strip position-absolute">#2</div>
                <div
                  class="cardFooter d-flex align-items-center justify-content-between"
                >
                  <div class="ltBlock">
                    <p>Balance</p>
                    <h4 class="mb-0 themecolor semibold">₿0.05200295</h4>
                  </div>
                  <div class="change">
                    <p>24h Change</p>
                    <p class="mb-0 status greenBG d-flex align-items-center">
                      <feather class="mr-1" type="trending-up"></feather>
                      0.0212%
                    </p>
                  </div>
                </div>
              </div> -->
            </VueSlickCarousel>
            <div class="text-center mt-md-5">
              <router-link
                to="/wallets"
                class="secondary medium d-inline-flex align-items-center justify-content-center"
                >See All Wallets
                <feather size="17px" type="arrow-right" class="ml-1"></feather
              ></router-link>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="recentTransaction blockSpace">
            <div
              class="topFilter-bar whiteBar d-flex align-items-center justify-content-between mb-3"
            >
              <h3 class="semibold mb-0">Recent Deposits</h3>
             
            </div>
            <div class="recentTable">
              <table
                class="table table-striped table-bordered"
                v-show="type == '2'"
              >
                <thead class="thead-white">
                  <tr>
                    <!--  v-if='basicAdv' -->
                    <th>Date/ Time</th>
                    <th>Transaction ID</th>
                    <th>Currency</th>
                    <th>Amount</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody v-if="depsitList.totalRecords">
                  <tr v-for="deposit in depsitList.records">
                    <td>
                      {{
                        deposit.created | moment("DD-MM-YYYY, h:mm:ss a")
                      }}
                    </td>
                    <td>{{ deposit.transaction_id }}</td>
                    <td>
                      <p v-if="$env_var.restricted_currencies.hasOwnProperty(deposit.currency)">{{ $env_var.restricted_currencies[deposit.currency].currency_name }}</p>
                      <p v-else>{{ deposit.currency || "-" }}</p>
                    <td>{{ deposit.amount }}</td>
                    <td>
                      <span class="status yellowBG">{{
                        depositStatus[deposit.payment_status].name
                      }}</span>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="text-center">No deposits yet</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import tradingMixins from "@/plugins/trading";
import depositWithdrawalMixins from "@/plugins/depositWithdrawal";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import math from "../../../../static/website/js/math.js";
import currencyChart from "../shared/chart/currencyChart";
import revenueChart from "../shared/chart/revenueChart";
import VueSlickCarousel from "vue-slick-carousel";
import moment from "moment";
export default {
  name: "index",
  mixins: [tradingMixins, depositWithdrawalMixins],
  data() {
    return {
      availableCurrencies: ["BTC", "ETH", "USDT", "USD"],
      selectedCurrency: "USD",
      pageLoader: false,
      tableFilter: false,
      targetTime: false,
      notification_msg: "",
      notification_type: "",
      exchangeTypeS: {
        M: "Market",
        S: "Stop",
        L: "Limit",
        SL: "Stop Limit",
      },
      type: "2",
      currency: "",
      freeMargin: 0,
      free_Margin: 0,
      tab: "deposit",
      searchcrypto: "",
      errImage: [],
      fev_list: [],
      margin_list: {}, // currency with ammount available in account
      curencyUsdValList: [],
      currencies: false,
      settings: {
        dots: true,
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        touchThreshold: 1,
      },
    };
  },
  watch: {
    tradingAccount(value) {
      if (!parseInt(this.accountSelected)) {
        this.getCurrency(value, 1);
      }
    },
    socialAccount(value) {
      if (parseInt(this.accountSelected) == 1) {
        this.getCurrency(value, 1);
      }
    },
  },
  components: {
    currencyChart,
    VueSlickCarousel,
    revenueChart,
  },
  computed: {
    instruments() {
      try {
        this.$store.getters[Const.GET_HEARTBEATS]["priceFeed"];
        return this.$store.getters[Const.GET_PROVIDERS][
          "priceFeed"
        ].iCache.asKeysValueArrayAll();
      } catch (ex) {
        return [];
      }
    },
    totalUsdValue() {
      try {
        let amount = 0;
        for (const item in this.margin_list) {
          amount += parseFloat(
            this.getConvertedValue(this.margin_list[item], "USD")
          );
        }
        return amount.toFixed(3);
      } catch (e) {
        return "N/A";
      }
    },
    totalBtcValue() {
      try {
        let amount = 0;
        for (const item in this.margin_list) {
          amount += parseFloat(
            this.getConvertedValue(
              this.margin_list[item],
              this.selectedCurrency
            )
          );
        }
        return this.formatfloat(amount.toFixed(8));
      } catch (e) {
        return "N/A";
      }
    },
    totalTransactionVolumne() {
      return this.revenueReport.length
        ? this.revenueReport.reduce((a, b) => a + b.value, 0)
        : 0;
    },
  },
  methods: {
    getCurrencyChange(base) {
      if (
        base != "USD" &&
        this.instruments &&
        this.instruments[`${base}-USD`]
      ) {
        return this.instruments[`${base}-USD`].CB;
      } else {
        return 0;
      }
    },
    changeCurencyUsdValList() {
      this.currencyData();
      setTimeout(() => {
        this.currencyData();
      }, 5000);
    },
    currencyData() {
      try {
        this.curencyUsdValList = [];
        for (const item in this.margin_list) {
          let index = this.curencyUsdValList
            .map((e) => e.currency)
            .indexOf(this.margin_list[item].currency);
          if (parseFloat(this.margin_list[item].amount)) {
            if (index == -1) {
              this.curencyUsdValList.push({
                currency: this.margin_list[item].currency,
                usdValue: this.getConvertedValue(this.margin_list[item], "USD"),
              });
            } else {
              this.curencyUsdValList[index]["usdValue"] =
                this.getConvertedValue(this.margin_list[item], "USD");
            }
          }
        }
        this.curencyUsdValList.sort(function (a, b) {
          return parseFloat(b.usdValue) - parseFloat(a.usdValue);
        });
      } catch (e) {
        setTimeout(() => {
          this.currencyData();
        }, 1000);
      }
    },
    fromDate(val) {
      return moment(val).fromNow();
    },
    getConvertedValue(item, currency) {
      if (item.currency == currency) {
        return item.amount;
      } else {
        let amount = 0;
        if (this.instruments[item.currency + "-" + currency]) {
          amount = this.instruments[item.currency + "-" + currency].A;
        } else if (this.instruments[currency + "-" + item.currency]) {
          return 1 / this.instruments[currency + "-" + item.currency].A;
        } else {
          let basePrice = null,
            reversebasePrice = null,
            pairValue = null,
            revpairValue = null;
          if (currency == "USD") {
            basePrice = this.instruments[item.currency + "-BTC"];
            reversebasePrice = this.instruments["BTC-" + item.currency];
            pairValue =
              this.instruments["BTC-USD"] || this.instruments["BTC-USDT"];
          } else {
            basePrice = this.instruments[item.currency + "-USD"];
            reversebasePrice = this.instruments["USD-" + item.currency];
            pairValue =
              this.instruments["USD-" + currency] ||
              this.instruments["USDT-" + currency];
          }
          if (basePrice && pairValue) {
            amount = pairValue.A * basePrice.A;
          } else if (reversebasePrice && pairValue) {
            amount = pairValue.A / reversebasePrice.A;
          } else {
            amount = 0;
          }
        }
        if (currency == "USD") {
          return (amount * item.amount).toFixed(3);
          // return (amount * item.amount).toFixed(3)
        } else {
          return this.formatfloat(amount * item.amount);
        }
      }
    },
    formatfloat(num) {
      if (num) {
        num = parseFloat(num);
        try {
          return math.format(num, { notation: "fixed" }) || "";
        } catch (e) {
          try {
            return num.toFixed(8);
          } catch (e) {
            return "";
          }
        }
      } else {
        return 0;
      }
    },
    redirect() {
      this.$router.replace({
        name: "support",
        params: { tabName: "openRequest", page: "view_dash" },
      });
    },
    parseFloatVal(val) {
      return parseFloat(val).toFixed(8);
    },
    isImage(img) {
      return this.errImage.includes(img) ? false : true;
    },
    handleImgErr(val) {
      var fullSrc = val.target.src.split(".");
      var src = fullSrc[fullSrc.length - 2].split("/");
      var img = src[src.length - 1];
      if (!this.errImage.includes(img)) {
        this.errImage.push(img);
      }
    },
    createClass(index) {
      index++;
      return "p" + index + " col" + index;
    },
    subscribe(subscribeArray) {
      try {
        /*let subscribeArray = [ "BTC-USD", "ETH-USD", "LTC-USD", "BCH-USDT", "ADA-USD", "EOS-USD" ];*/
        this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
          "S_PF_PF"
        ].subscribe(subscribeArray);
      } catch (e) {}
    },
    /*currencyListFunc() {
      try {
        if (this.searchcrypto == "") {
          return this.tradingAccount[0].subAccounts;
        } else {
          return this.tradingAccount[0].subAccounts.filter((val) =>
            val.currency.toLowerCase().includes(this.searchcrypto.toLowerCase())
          );
        }
      } catch (e) { return []; }
    },*/
    allListing() {
      var data = {
        globalParams: {
          filter: {},
          sort: [],
          search: "",
          page: "1",
          perPage: 4,
        },
        localParams: { parameter: this },
      };
      this._runGetDepsitList(data);
      this._runGetWithdrawalList(data);
    },
    orderData(type) {
      if (type == "1") {
        return this.orderList.records.filter((val) => val.Status == "CREATED");
      } else if (type == "2") {
        return this.orderList.records.filter((val) => val.Status == "FILLED");
      } else if (type == "3") {
        return this.orderList.records.filter((val) => val.Status == "CANCELED");
      } else {
        return [];
      }
    },
    getCurrency(value, isCalling) {
      if (value.length > 0 && value[0].subAccounts.length > 0) {
        this.currency = value[0].subAccounts[0];
        let btcPair = value[0].subAccounts.map((val) => val.currency + "-BTC");
        let usdPair = value[0].subAccounts.map((val) => val.currency + "-USD");
        this.subscribPairs(btcPair.concat(usdPair));
        this._runGetMarginInfo({
          globalParams: { account_id: value[0].account_id },
          localParams: { parameter: this, page: "home" },
        });
        if (
          value.length > 0 &&
          (this.orderList.records.length == 0 || isCalling)
        ) {
          let jsonData = {
            globalParams: {
              account_id: value[0].account_id,
              demo_live: value[0].demo_live,
            },
            localParams: { parameter: this },
          };
          this._runGetOrderList(jsonData);
        }
      }
    },
    subscribPairs(pairList) {
      try {
        if (pairList.length > 0) {
          this.$store.getters[Const.GET_PROVIDERS]["priceFeed"].seeders[
            "S_PF_PF"
          ].subscribe(pairList);
        }
      } catch (e) {
        setTimeout(() => {
          this.subscribPairs(pairList);
        }, 1000);
      }
    },
    /* orderData(){
            return this.orderList.records.filter( val => val.Status == 'FILLED')
        },
    orderlisting(){
      if(this.tradingAccount.length > 0){
        let jsonData = {
          'globalParams' :{
            'account_id' : this.tradingAccount[0].account_id,
            'demo_live' : this.tradingAccount[0].demo_live
          },
          'localParams' :{"parameter" : this, 'page' : 'home'}
        }
        this._runGetOrderList(jsonData)
      }
        }*/
  },
  created() {
    this._runGetProfileInfo({
      globalParams: {},
      localParams: {
        parameter: this,
      },
    });
    var _that = this;
    if (parseInt(this.accountSelected) == 1) {
      this.getCurrency(this.socialAccount, 0);
    } else {
      this.getCurrency(this.tradingAccount, 0);
    }
    setTimeout(function () {
      _that.subscribe([
        "BTC-USD",
        "ETH-USD",
        "LTC-USD",
        "BCH-USDT",
        "ADA-USD",
        "EOS-USD",
      ]);
    }, 2000);
    this._getfavoriteCurrencyList({
      globalParams: { type: "isin" },
      localParams: { parameter: this, page: "home" },
    });
    // this.orderlisting()
    this.allListing();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/website/user/merchant_home.vue